/*
 * @Descripttion:
 * @version:
 * @Author: linxi
 * @email: 2194421430@qq.com
 * @Date: 2021-05-24 15:25:12
 * @LastEditors: linxi
 * @LastEditTime: 2021-09-09 11:29:42
 */

import { Breadcrumb, Layout, Menu } from "antd";
import React, { useEffect, useState } from "react";
import { Link, Route, Switch, useLocation } from "react-router-dom";
import { getMenuTitleName } from "../../models/menuTitle";
import { ExceptionListMessage } from "../ExceptionMessage/ExceptionMessage";
import { FileData } from "../FileData/fileData";
import { OrganizationListMessage } from "../OrganizationMessage/OrganizationMessage";
import { ProcessingData } from "../ProcessingData/ProcessingData";
import styles from "./recardCenter.module.css";

const { Sider, Content } = Layout

export const RecordsCenterLayout = () => {
  const location = useLocation()

  const [selectedKey, setSelectedKey] = useState("")

  useEffect(() => {
    const paths = location.pathname.split("/")
    if (paths.length === 2) {
      setSelectedKey("ProcessingData");
    } else if (
      paths.length >= 3 &&
      [
        "ProcessingData",
        // "FileData",
        "ExceptionListMessage",
        "OrganizationListMessage",
      ].includes(paths[2])
    ) {
      setSelectedKey(paths[2])
    }
  }, [location])
  return (
    <Layout style={{ height: "100%", width: "100%" }}>
      <Sider width={240} style={{ background: "#fff" }}>
        <Menu
          theme='light'
          mode='inline'
          defaultSelectedKeys={["1"]}
          selectedKeys={[selectedKey]}
          onSelect={({ key }) => setSelectedKey(key as string)}
          style={{ fontSize: "16px" }}
          className={styles.menu}
        >
          <Menu.Item key="ProcessingData">
            <Link to="/datacenter/ProcessingData">处置数据</Link>
          </Menu.Item>
          {/* <Menu.Item key="FileData">
            <Link to="/datacenter/FileData">处置数据</Link>
          </Menu.Item> */}
          <Menu.Item key="ExceptionListMessage">
            <Link to="/datacenter/ExceptionListMessage">预警数据</Link>
          </Menu.Item>
          <Menu.Item key='OrganizationListMessage'>
            <Link to='/datacenter/OrganizationListMessage'>机构数据</Link>
          </Menu.Item>
        </Menu>
      </Sider>
      <Layout>
        <Breadcrumb style={{ position: "relative", left: "20px", top: "10px" }}>
          <Breadcrumb.Item>数据中心</Breadcrumb.Item>
          <Breadcrumb.Item>{getMenuTitleName(selectedKey)}</Breadcrumb.Item>
        </Breadcrumb>
        <Content
          style={{
            margin: "20px",
            minHeight: 280,
          }}
        >
          <Switch>
            <Route exact path={["/datacenter", "/datacenter/ProcessingData"]}>
              <ProcessingData />
            </Route>
            {/* <Route exact path={["/datacenter", "/datacenter/FileData"]}>
              <FileData />
            </Route> */}
            <Route exact path="/datacenter/OrganizationListMessage">
              <OrganizationListMessage />
            </Route>
            <Route exact path='/datacenter/ExceptionListMessage'>
              <ExceptionListMessage />
            </Route>
          </Switch>
        </Content>
      </Layout>
    </Layout>
  )
}
